export default "__VITE_ASSET__5b5ac6f3__"